import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { fmtINR } from "@/lib/api";
import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { Star, ArrowRight } from "lucide-react";

export default function Destinations() {
  const [params] = useSearchParams();
  const q = (params.get("q") || "").toLowerCase();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/destinations").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  const filtered = q ? items.filter((d) => `${d.name} ${d.country}`.toLowerCase().includes(q)) : items;

  return (
    <div data-testid="destinations-page">
      <PageHero
        kicker="Destination Guides"
        title="Discover the world, one journey at a time"
        subtitle="In-depth destination guides for the most loved travel spots — with visa info, hotels, deals and tips."
      />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "Destinations" }]} />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((d) => (
            <Link to={`/destinations/${d.slug}`} key={d.slug} data-testid={`destination-${d.slug}`} className="group bg-white border border-slate-200 rounded-2xl overflow-hidden card-hover">
              <div className="relative h-56 overflow-hidden">
                <img src={d.image} alt={d.name} className="w-full h-full object-cover img-zoom" loading="lazy" />
                <div className="absolute top-3 left-3 px-2 py-1 text-[10px] uppercase tracking-widest font-bold bg-white/95 text-brand rounded">
                  {d.country}
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-montserrat font-bold text-xl text-slate-900">{d.name}</h3>
                <p className="text-sm text-slate-600 mt-1">{d.tagline}</p>
                <div className="flex items-center gap-3 mt-3 text-xs text-slate-500">
                  <span className="inline-flex items-center gap-1"><Star size={12} className="text-accent fill-accent" /> {d.rating}</span>
                  <span>· Best: {d.best_time}</span>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <div className="text-sm">
                    From <span className="font-montserrat font-bold text-slate-900">{fmtINR(d.from_price)}</span>
                  </div>
                  <span className="text-sm font-semibold text-brand inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    View Guide <ArrowRight size={14} />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
